<template>
  <label class="flex flex-row items-center cursor-pointer">
    <input
      class="hidden"
      type="radio"
      :name="name"
      :checked="value"
      @change.prevent="onChange"
    />
    <slot name="check" v-bind="{ checked }">
      <span
        class="w-5 h-5 rounded-full border-2 relative mr-2"
        :class="{
          'border-primary-200 bg-primary-200': value,
          'border-neutral-150': !value,
        }"
      >
        <!-- eslint-disable -->
        <span
          class="block w-full h-full rounded-full bg-white absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all duration-75"
          :class="{
            'max-w-8px max-h-8px': value,
            'max-w-0 max-h-0': !value,
          }"
        />
        <!-- eslint-enable -->
      </span>
    </slot>
    <slot v-bind="{ checked }">
      <span
        class="text-base"
        :class="{
          'text-neutral-50': !value,
        }"
      >
        {{ label }}
      </span>
    </slot>
  </label>
</template>

<script>
import uniqid from 'uniqid';

export default {
  name: 'FormRadio',
  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: () => uniqid(),
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checked() {
      return this.value;
    },
  },
  methods: {
    onChange(event) {
      const { checked } = event.target;
      if (checked) {
        this.$emit('check');
      } else {
        this.$emit('uncheck');
      }
      this.$emit('input', checked);
    },
  },
};
</script>
